import { createAsyncThunk } from '@reduxjs/toolkit';
import reportsApi from '~/apis/reports';
import {
  EXPORT_DATA_REPORT,
  GET_LIST_CANCELLATION_REPORT,
  GET_LIST_CLIENT_INCOME_REPORT,
  GET_LIST_DELIVERY_PICKUP_REPORT,
  GET_LIST_DISCOUNT_USAGE_REPORT,
  GET_LIST_FEATURE_UTILIZATION_REPORT,
  GET_LIST_FINANCIAL_ORDER_REPORT,
  GET_LIST_FOREMAN_TASK_COMPLETION_REPORT,
  GET_LIST_GEOGRAPHY_REVENUE_REPORT,
  GET_LIST_INVENTORY_USAGE_REPORT,
  GET_LIST_JOB_COSTING_REPORT,
  GET_LIST_MARKETING_REVENUE_REPORT,
  GET_LIST_ORDER_REVENUE_REPORT,
  GET_LIST_OVERBOOKING_ITEM_REPORT,
  GET_LIST_QUOTE_REVENUE_REPORT,
  GET_LIST_REVENUE_REPORT,
  GET_LIST_SUBRENTALS_REPORT,
  GET_LIST_TASK_COMPLETION_REPORT,
  GET_LIST_TRANSACTION_SUMMARY_REPORT,
} from '~/utils/constants/actionType';
import { IQueryParamListExport } from '~/utils/interface/reports';

export const getListOverbookingItemReport = createAsyncThunk(
  GET_LIST_OVERBOOKING_ITEM_REPORT,
  async (params: IQueryParamListExport, { rejectWithValue }) => {
    try {
      const resp = await reportsApi.getListOverbookingItemReport(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getListSubRentalsReport = createAsyncThunk(
  GET_LIST_SUBRENTALS_REPORT,
  async (params: IQueryParamListExport, { rejectWithValue }) => {
    try {
      const resp = await reportsApi.getListSubRentalsReport(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getListClientIncomeReport = createAsyncThunk(
  GET_LIST_CLIENT_INCOME_REPORT,
  async (params: IQueryParamListExport, { rejectWithValue }) => {
    try {
      const resp = await reportsApi.getListClientIncomeReport(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getListRevenueReport = createAsyncThunk(
  GET_LIST_REVENUE_REPORT,
  async (params: IQueryParamListExport, { rejectWithValue }) => {
    try {
      const resp = await reportsApi.getListRevenueReport(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getListGeographyRevenueReport = createAsyncThunk(
  GET_LIST_GEOGRAPHY_REVENUE_REPORT,
  async (params: IQueryParamListExport, { rejectWithValue }) => {
    try {
      const resp = await reportsApi.getListGeographyRevenueReport(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getListQuoteRevenueReport = createAsyncThunk(
  GET_LIST_QUOTE_REVENUE_REPORT,
  async (params: IQueryParamListExport, { rejectWithValue }) => {
    try {
      const resp = await reportsApi.getListQuoteRevenueReport(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getListOrderRevenueReport = createAsyncThunk(
  GET_LIST_ORDER_REVENUE_REPORT,
  async (params: IQueryParamListExport, { rejectWithValue }) => {
    try {
      const resp = await reportsApi.getListOrderRevenueReport(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getListCancellationReport = createAsyncThunk(
  GET_LIST_CANCELLATION_REPORT,
  async (params: IQueryParamListExport, { rejectWithValue }) => {
    try {
      const resp = await reportsApi.getListCancellationReport(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getListDeliveryPickupReport = createAsyncThunk(
  GET_LIST_DELIVERY_PICKUP_REPORT,
  async (params: IQueryParamListExport, { rejectWithValue }) => {
    try {
      const resp = await reportsApi.getListDeliveryPickupReport(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getListTaskCompletionReport = createAsyncThunk(
  GET_LIST_TASK_COMPLETION_REPORT,
  async (params: IQueryParamListExport, { rejectWithValue }) => {
    try {
      const resp = await reportsApi.getListTaskCompletionReport(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getListDiscountUsageReport = createAsyncThunk(
  GET_LIST_DISCOUNT_USAGE_REPORT,
  async (params: IQueryParamListExport, { rejectWithValue }) => {
    try {
      const resp = await reportsApi.getDiscountUsageReport(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getListFeatureUtilizationReport = createAsyncThunk(
  GET_LIST_FEATURE_UTILIZATION_REPORT,
  async (params: IQueryParamListExport, { rejectWithValue }) => {
    try {
      const resp = await reportsApi.getListFeatureUtilizationReport(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getListJobCostingReport = createAsyncThunk(
  GET_LIST_JOB_COSTING_REPORT,
  async (params: IQueryParamListExport, { rejectWithValue }) => {
    try {
      const resp = await reportsApi.getListJobCostingReport(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getListInventoryUsageReport = createAsyncThunk(
  GET_LIST_INVENTORY_USAGE_REPORT,
  async (params: IQueryParamListExport, { rejectWithValue }) => {
    try {
      const resp = await reportsApi.getListInventoryUsageReport(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getListForemanTaskCompletionReport = createAsyncThunk(
  GET_LIST_FOREMAN_TASK_COMPLETION_REPORT,
  async (params: IQueryParamListExport, { rejectWithValue }) => {
    try {
      const resp = await reportsApi.getListForemanTaskCompletionReport(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getListMarketingRevenueReport = createAsyncThunk(
  GET_LIST_MARKETING_REVENUE_REPORT,
  async (params: IQueryParamListExport, { rejectWithValue }) => {
    try {
      const resp = await reportsApi.getListMarketingRevenueReport(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getListFinancialOrderReport = createAsyncThunk(
  GET_LIST_FINANCIAL_ORDER_REPORT,
  async (params: IQueryParamListExport, { rejectWithValue }) => {
    try {
      const resp = await reportsApi.getListFinancialOrderReport(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getListTransactionSummaryReport = createAsyncThunk(
  GET_LIST_TRANSACTION_SUMMARY_REPORT,
  async (params: IQueryParamListExport, { rejectWithValue }) => {
    try {
      const resp = await reportsApi.getListTransactionSummaryReport(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const exportDataReport = createAsyncThunk(
  EXPORT_DATA_REPORT,
  async (params: IQueryParamListExport, { rejectWithValue }) => {
    try {
      const resp = await reportsApi.exportDataReport(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
